export const User = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.125 5.41675C13.125 7.14264 11.7258 8.54175 9.99996 8.54175C8.27407 8.54175 6.87496 7.14264 6.87496 5.41675C6.87496 3.69086 8.27407 2.29175 9.99996 2.29175C11.7258 2.29175 13.125 3.69086 13.125 5.41675Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9.99996 11.0417C7.174 11.0417 5.02995 12.7204 4.15202 15.0942C3.81135 16.0153 4.59856 16.8751 5.58065 16.8751H14.4193C15.4014 16.8751 16.1886 16.0153 15.8479 15.0942C14.97 12.7204 12.8259 11.0417 9.99996 11.0417Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

export default User
